import Title from "../layouts/Title";
import ProjectsCard from "./ProjectsCard";
import { ProjectList } from "./ProjectList";

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        {ProjectList.map((item) => {
          return (
            <ProjectsCard
              key={item.id}
              src={item?.src ? item.src : "https://img.freepik.com/free-vector/illustration-gallery-icon_53876-27002.jpg"}
              title={item.title}
              des={item.des}
              link={item.link}
              repo={item.repo}
              skills={item.skills}
            />
          );
        })}
      </div>
    </section>
  );
};

export default Projects;